import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledHelperText = styled.div`
  margin-top: 0.125rem;
  color: ${COLORS.IRON_GRAY};
  ${pickThemeFontStyles('12', '16', 'SMALL')};
`;
